<template>
  <div style="height: 100%" class="ls_spin_container">
    <h1 class="company_header">{{ company_name }}</h1>
    <p class="color-grey mb-30">Создан {{ createdDate }}</p>

    <Tabs style="height: 100%" class="company__tab">
      <TabPane label="Основные" icon="ios-settings-outline">
        <companyMainSettings></companyMainSettings>
      </TabPane>
      <TabPane label="Реквизиты" icon="ios-document-outline">
        <companyExtraSettings></companyExtraSettings>
      </TabPane>

      <TabPane v-if="use_fiscal" label="Дополнительно" icon="md-star-outline">
        <companyLKSettings></companyLKSettings>
      </TabPane>

      <TabPane label="Логотип компании" icon="ios-image">
        <companyLogo></companyLogo>
<!--        <companyExtraSettings></companyExtraSettings>-->
      </TabPane>
      <!--<TabPane label="Рассылки">-->
      <!--&lt;!&ndash;<companyMailingSettings></companyMailingSettings>&ndash;&gt;-->
      <!--</TabPane>-->
    </Tabs>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDateTime } from "../../base/base_func.js";
import { base_url } from "../../http.js";
import companyMainSettings from "@/apps/company/companyMainSettings";
import companyExtraSettings from "@/apps/company/companyExtraSettings";
import companyMailingSettings from "@/apps/company/companyMailingSettings";
import companyLogo from "@/apps/company/companyLogo";
import companyLKSettings from "@/integration/lkassa/company/companyLKSettings";

export default {
  name: "company",
  data() {
    return {
      baseViewUrl: base_url + "/company/main/",
      createdDate: ""
    };
  },
  components: {
    companyMainSettings,
    companyExtraSettings,
    companyMailingSettings,
    companyLKSettings,
    companyLogo
  },
  computed:{
    ...mapState([
      "user_id",
      "user_full_name",
      "current_view",
      "current_view_parent",
      "currency",
      "permissions",
      "role",
      "role_display",
      "use_fiscal",
      "company_name",
      "cashes"
    ])
  },
  methods: {
    fetchCompany() {
      this.$http
        .get(this.baseViewUrl)
        .then(response => {
          this.$store.commit("company_name", response.data.name);
          this.createdDate = this.formatDateTime(response.data.created_date);
        })
        .catch(error => {
          this.$Message.error("Произошла ошибка");
        });
    },
    formatDateTime (datetime) {
      return formatDateTime(datetime);
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.fetchCompany();
    this.loading = false;
  }
};
</script>

<style scoped>
.company_header {
  margin-bottom: 20px;
}


</style>


<style>
  .company__tab .ivu-tabs-nav .ivu-tabs-tab {
    margin-bottom: 0;
  }

  .company__tab .ivu-tabs-nav-prev {
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
  }

  .company__tab .ivu-tabs-nav-next {
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
  }



  @media screen and (max-width: 767px) {
    .company__tab .ivu-tabs-nav-scrollable {
      padding: 0 18px;
    }


    .company__tab .ivu-tabs-nav .ivu-tabs-tab i {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/company/company.vue